import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteOpinionThoughts,
  getOpinionThoughts,
  restoreOpinionThoughts,
  updateOpinionThoughts,
} from "../../../api";
import EditNewsForm from "../../EditNewsForm";

export default function EditOpinionThoughts() {
  const location = useLocation();
  const navigate = useNavigate();

  const customSubmitFunction = async (id, title, description, image) => {
    try {
      const result = await updateOpinionThoughts(id, title, description, image);
      if (result) {
        navigate("/opinion-thoughts/all");
      }
    } catch (error) {}
  };

  const publishOpinionThoughts = async (id) => {
    try {
      await restoreOpinionThoughts(id);

      navigate("/opinion-thoughts/all");
    } catch (error) {}
  };
  const unPublishOpinionThoughts = async (id) => {
    try {
      await deleteOpinionThoughts(id);

      navigate("/opinion-thoughts/all");
    } catch (error) {
      throw error;
    }
  };

  const getOneOpinionThoughts = async (id) => {
    try {
      const result = await getOpinionThoughts(id);
      return result;
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <Container>
        <EditNewsForm
          ItemId={location?.state?.opinionThoughtsId}
          breadCrumbLink={"Opinion and Thoughts"}
          breadCrumbText={"Edit News"}
          goBackLink={"/opinion-thoughts/all"}
          customsubmit={customSubmitFunction}
          publishItem={publishOpinionThoughts}
          unPublishItem={unPublishOpinionThoughts}
          getOneItem={getOneOpinionThoughts}
        />
      </Container>
    </>
  );
}
